import SocialHandle from "../components/socialHandle.jsx";

const myInformation =
  "I’m a creative frontend developer focused on building fast, scalable, and user-friendly web applications using React, Node.js, Firebase, and MongoDB. In addition to development, I run and grow digital storytelling platforms across Facebook, Instagram, TikTok, and Threads, driving high audience engagement through creative content and online campaigns.";

  const MySummary = [
    {
      title: "What I do",
      message: "I design, build, and deploy modern web applications with a strong focus on usability, performance, and real-world impact. My work blends technical problem-solving with product thinking, ensuring the solutions I build are practical, scalable, and user-focused."
    },
    {
      title: "Current Work",
      message: "I currently build frontend web applications and run StoryPlugs, a global storytelling platform with 153k+ followers. I personally designed, developed, and deployed the StoryPlugs website using React and modern web technologies."
    },
    {
      title: "How I Work",
      message: "I approach development with a product mindset, prioritizing clean code, responsiveness, accessibility, and continuous learning. I value collaboration, adaptability, and building tools that people genuinely enjoy using."
    }
  ];
  
const About = () => {


  return ( 
    <div className="about-page"> 
      <section className="hero-section" style={{ textAlign: 'center' }} >
        <h3 style={{marginBottom: '-1em'}}>I am</h3>
        <h3>Precious M. Ayeni-Fatomilola</h3>
        <p>Frontend Developer & Social Media Influencer/Manager</p>
      </section>

    <hr className="divider" />

      <section className="about-section">
        <img
          src="/img/Official-DP.jpeg"
          alt="My Profile"
          width="200"
          className="profile-picture"
        />
        <div className="bio">
          <h3>About Me</h3>
          <p>{myInformation}</p>
        </div>

      </section>


   
      <div style={{backgroundColor: '#0e1a2b'}}>
      <section className="projects">
        <div className="project-grid">
          {MySummary.map((id) =>(
            <div className="project-card">
              <h4 style={{textAlign: 'center'}}>{id.title}</h4>
              <p style={{textAlign: 'center'}}>{id.message}</p>
            </div>
          ))}
          <h2>{MySummary.title}</h2>
          <p>{MySummary.message}</p>
        </div>
      </section>
      </div>

      <section className="skills-section">
        <h3> Tech Stack</h3>
        <ul className="skills-list">
          <li>React, JavaScript (ES6+), HTML, CSS</li>
          <li>Firebase, MongoDB</li>
          <li>OpenAI API, Paystack, Cloudinary, Agolia</li>
          <li>Git, REST APIs, modern deployment tools</li>
          <li>Content Creation / Engagement Strategy</li>
        </ul>
      </section>

    <hr className="divider" />

      <div className="skills-section">
        <h3>Selected Highlights</h3>
        <ul className="skills-list">
          <li>Built an AI Productivity Dashboard integrating AI tools with task and workflow management</li>
          <li>Developed a Local Services Marketplace connecting service providers with clients</li>
          <li>Created a fully functional E-commerce web application with secure Paystack payments</li>
          <li>Founder of StoryPlugs, managing content strategy, analytics, and platform growth</li>
        </ul>
      </div>
    
      <div style={{backgroundColor: '#0e1a2b', padding: 25}}>
        <h3 style={{color: 'white'}}>Availability</h3>
        <p style={{color: 'white'}}>Open to frontend, full-stack, and junior–mid level roles, including remote and international opportunities.</p>
      </div> 

        <SocialHandle/>
      
    </div>
  );
};

export default About;